import React from 'react';
import styles from './BookingCard.module.css';

const BookingCard = ({ booking, action }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getPaymentStatusClass = (status) => {
    const map = {
      'PAID': styles.paid,
      'PARTIAL': styles.partial,
      'UNPAID': styles.unpaid,
    };
    return map[status] || styles.unpaid;
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.bookingNumber}>{booking.bookingNumber}</div>
        <div className={styles.amount}>{formatCurrency(booking.totalAmount)}</div>
      </div>
      
      <div className={styles.guestInfo}>
        <div className={styles.guestName}>{booking.guestName}</div>
        {booking.guestPhone && (
          <div className={styles.guestPhone}>{booking.guestPhone}</div>
        )}
      </div>

      <div className={styles.details}>
        <div className={styles.detailItem}>
          <span className={styles.label}>Rooms:</span>
          <span className={styles.value}>{booking.roomCount || 0}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.label}>Beds:</span>
          <span className={styles.value}>{booking.bedCount || 0}</span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.label}>Status:</span>
          <span className={`${styles.badge} ${styles.statusBadge}`}>
            {booking.status}
          </span>
        </div>
        <div className={styles.detailItem}>
          <span className={styles.label}>Payment:</span>
          <span className={`${styles.badge} ${getPaymentStatusClass(booking.paymentStatus)}`}>
            {booking.paymentStatus}
          </span>
        </div>
      </div>

      <div className={styles.action}>
        {action}
      </div>
    </div>
  );
};

export default BookingCard;
